import {MutationTree} from "vuex";
import {ReportsState} from "@/store/reports/types";

export const mutations: MutationTree<ReportsState> = {
  setReports:((state, payload) => state.reports = payload),
  setSummaryGroup:((state, payload) => state.summaryGroup = payload)
}